/** Spoken words after what is already in the box. */
export function joinSpoken(text: string, words: string): string {
  return text ? `${text}${words}` : words;
}
